<template>
  <div class="_bg">
    <div class="_tabsDiv">
      <el-tabs
        class="custom-tabs"
        style="margin-top: 20px"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="全部" name="first">
          <div class="_all">
            <el-table :data="projiectData" border v-loading="pageLoading">
              <el-table-column type="index" label="序号" width="100">
              </el-table-column>
              <el-table-column prop="" label="审批单类型">
                <template slot-scope="scope">
                  <span>项目立项</span>
                </template>
              </el-table-column>
              <el-table-column prop="contractNo" label="合同编号">
              </el-table-column>
              <el-table-column prop="projectName" label="项目名称">
              </el-table-column>
              <el-table-column prop="managerName" label="项目经理">
              </el-table-column>
              <el-table-column prop="amount" label="项目总额">
                <template slot-scope="scope">
                  <span>{{ '￥' + scope.row.amount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="applyName" label="项目日期">
                <template slot-scope="scope">
                  <span>{{
                    formatDate(scope.row.startDate) +
                    '-' +
                    formatDate(scope.row.endDate)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="projectDetail(scope.row.id)"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待审批" name="second">
          <div class="_wait">
            <el-table :data="projiectData" border v-loading="pageLoading">
              <el-table-column type="index" label="序号" width="100">
              </el-table-column>
              <el-table-column prop="" label="审批单类型">
                <template slot-scope="scope">
                  <span>项目立项</span>
                </template>
              </el-table-column>
              <el-table-column prop="contractNo" label="合同编号">
              </el-table-column>
              <el-table-column prop="projectName" label="项目名称">
              </el-table-column>
              <el-table-column prop="managerName" label="项目经理">
              </el-table-column>
              <el-table-column prop="amount" label="项目总额">
                <template slot-scope="scope">
                  <span>{{ '￥' + scope.row.amount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="applyName" label="项目日期">
                <template slot-scope="scope">
                  <span>{{
                    formatDate(scope.row.startDate) +
                    '-' +
                    formatDate(scope.row.endDate)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="projectDetail(scope.row.id)"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="审批历史" name="third">
          <div class="_history">
            <el-table :data="projiectData" border v-loading="pageLoading">
              <el-table-column type="index" label="序号" width="100">
              </el-table-column>
              <el-table-column prop="" label="审批单类型">
                <template slot-scope="scope">
                  <span>项目立项</span>
                </template>
              </el-table-column>
              <el-table-column prop="contractNo" label="单号">
              </el-table-column>
              <el-table-column prop="projectName" label="项目名称">
              </el-table-column>
              <el-table-column prop="managerName" label="项目经理">
              </el-table-column>
              <el-table-column prop="amount" label="项目总额">
                <template slot-scope="scope">
                  <span>{{ '￥' + scope.row.amount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="applyName" label="项目日期">
                <template slot-scope="scope">
                  <span>{{
                    formatDate(scope.row.startDate) +
                    '-' +
                    formatDate(scope.row.endDate)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="审核结果">
                <template slot-scope="scope">
                  <el-tag :type="getType(scope.row.status)" effect="dark">
                    {{ getName(scope.row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="projectDetail(scope.row.id)"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="_pageSelect">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 50, 100]"
        :page-size="this.postParams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import ProjectApplyApi from '@/api/projectApply';
export default {
  data() {
    return {
      activeName: 'first',
      projiectData: [],
      postParams: {
        auditType: 0, //审批类型，0：全部 1：待审批 2：审批历史
        contractName: '',
        current: 0,
        projectName: '',
        size: 10,
      },
      pageLoading: false,
      totalCount: 0,
    };
  },
  methods: {
    getName(status) {
      return {
        0: '待审核',
        1: '通过',
        2: '驳回',
      }[status];
    },
    getType(status) {
      return {
        0: '',
        1: 'success',
        2: 'danger',
      }[status];
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${year}.${month}.${day}`;
    },
    handleClick(tab, event) {
      // auditType: 0=全部, 1=待审批, 2=审批历史
      const auditTypeMap = {
        'first': 0,
        'second': 1,
        'third': 2
      };
      this.postParams.auditType = auditTypeMap[tab.name];
      this.queryProjectList(this.postParams);
      console.log("参数", this.postParams);
    },
    filterHandler(value, row, column) {
      const property = column.property;
      return row[property] === value;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.postParams.size = val;
      this.postParams.current = 1;
      this.queryProjectList(this.postParams);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.postParams.current = val;
      this.queryProjectList(this.postParams);
    },
    async queryProjectList(params) {
      this.pageLoading = true;
      const res = await ProjectApplyApi.queryProjectList(params);
      this.projiectData = res.data.data.records;
      this.totalCount = res.data.data.total;
      this.pageLoading = false;
    },
    projectDetail(data) {
      this.$router.push('/projectApplyDetail?id=' + data);
    },
  },
  created() {
    this.queryProjectList(this.postParams);
  },
};
</script>

<style scope lang="scss">
._bg {
  width: 100%;
  height: 100%;
  .el-tabs__item {
    width: 150px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding-left: 20px;
  }
}

._tabsDiv {
  height: calc(100% - 60px);
  width: 100%;
  overflow-y: auto;
}

._all,
._wait,
._history {
  padding: 20px;
}

._pageSelect {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
}

.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0;
}

/* span 宽高 */
._divSpan {
  display: inline-block;
  font-size: 16px;
  color: white;
  width: 80px;
  padding-top: 10px;
  height: 40px;
}
</style>
<style>
.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  text-align: center;
}
</style>
